const CalendarFab = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
  >
    <g clipPath="url(#clip0_556_16090)">
      <g filter="url(#filter0_d_556_16090)">
        <rect
          x="0.170898"
          y="0.170898"
          width="25.6579"
          height="25.6579"
          rx="3.42105"
          fill="#E8CDFD"
        />
      </g>
      <path
        d="M0.170898 3.59195C0.170898 1.70256 1.70256 0.170898 3.59195 0.170898H22.4077C24.2971 0.170898 25.8288 1.70256 25.8288 3.59195V8.72353H0.170898V3.59195Z"
        fill="#9933FF"
      />
      <g filter="url(#filter1_d_556_16090)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.639 18.3947L26.6837 18.351L26.4753 18.136H26.684V23.7078C26.684 23.8778 26.6685 24.0442 26.639 24.2057L26.639 18.3947ZM23.1313 21.8301L26.639 18.3697V18.3947L23.1313 21.8301ZM18.4412 26.4569L23.1313 21.8301L18.407 26.4569H18.4069L18.1944 26.2376L26.4667 18.136H26.4753L26.4711 18.1316L26.4667 18.136H20.8804C19.3621 18.136 18.1313 19.3668 18.1313 20.885V26.4569H18.4069L18.4069 26.4569L18.407 26.4569H18.4412ZM23.4463 26.4569H18.4412L18.2107 26.6843L23.4463 26.4569ZM24.4172 26.4147C25.5437 26.2154 26.4333 25.33 26.639 24.2057L26.639 26.3183L24.4172 26.4147ZM24.4172 26.4147L23.4463 26.4569H23.9349C24.0994 26.4569 24.2606 26.4424 24.4172 26.4147Z"
          fill="white"
          fillOpacity="0.3"
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M12.5728 18.7034L10.5826 19.7982C10.5235 19.8305 10.457 19.8449 10.3906 19.8398C10.3242 19.8347 10.2605 19.8104 10.2065 19.7694C10.1525 19.7285 10.1104 19.6727 10.0849 19.6081C10.0594 19.5435 10.0515 19.4728 10.0621 19.4037L10.4424 17.0842L8.83234 15.442C8.78428 15.3932 8.75026 15.3312 8.73414 15.2631C8.71803 15.195 8.72048 15.1235 8.74122 15.0568C8.76195 14.9901 8.80014 14.9308 8.85141 14.8858C8.90268 14.8408 8.96498 14.8118 9.03118 14.8022L11.2561 14.4635L12.2512 12.3537C12.281 12.2909 12.3268 12.238 12.3837 12.2011C12.4405 12.1641 12.506 12.1445 12.5728 12.1445C12.6397 12.1445 12.7052 12.1641 12.762 12.2011C12.8189 12.238 12.8647 12.2909 12.8945 12.3537L13.8896 14.4635L16.1145 14.8022C16.1805 14.8122 16.2426 14.8413 16.2936 14.8864C16.3447 14.9315 16.3827 14.9906 16.4034 15.0572C16.4241 15.1237 16.4266 15.1951 16.4107 15.2631C16.3948 15.3311 16.3611 15.393 16.3134 15.442L14.7033 17.0842L15.0827 19.4028C15.0941 19.4719 15.0868 19.543 15.0616 19.608C15.0364 19.673 14.9944 19.7293 14.9403 19.7705C14.8862 19.8117 14.8222 19.8361 14.7555 19.841C14.6888 19.8459 14.6222 19.8311 14.5631 19.7982L12.5728 18.7034Z"
        fill="#9933FF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_556_16090"
        x="-10.0923"
        y="-7.35542"
        width="46.184"
        height="46.1843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.73684" />
        <feGaussianBlur stdDeviation="5.13158" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.5 0 0 0 0 0 0 0 0 0 1 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_556_16090"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_556_16090"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_556_16090"
        x="15.6877"
        y="15.688"
        width="10.9963"
        height="10.9963"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.22181" dy="-1.22181" />
        <feGaussianBlur stdDeviation="0.610903" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.501961 0 0 0 0 0 0 0 0 0 1 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_556_16090"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_556_16090"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_556_16090">
        <rect width="26" height="26" rx="4.10526" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CalendarFab;
